import { Col, Row } from "antd";
import { HARDWARE_TYPE } from "../../constants/OppContants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QRCodeComponent from "../QRCodeComponent";
import { useState } from "react";

const HardwareDetailsComponent = ({
  hardwareDetails,
  productType,
  expand,
  groupId,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleQRClick = (uniqueKey) => {
    let newVal = isModalOpen !== uniqueKey ? uniqueKey : null;
    setIsModalOpen(newVal);
  };

  const cardDetailsLayout = (hardwareModel, index) => {
    const hardwareType = hardwareDetails[hardwareModel][0].deviceType;
    const count = hardwareDetails[hardwareModel].length;

    let colStyle = {
      backgroundColor: index % 2 === 0 ? "#29afff22" : "",
      borderRight:
        index < Object.keys(hardwareDetails)?.length - 1
          ? ".5px solid #29afff77"
          : "",
      borderBottomLeftRadius: !expand && index === 0 ? "8px" : "",
      borderBottomRightRadius:
        !expand && index === Object.keys(hardwareDetails)?.length - 1
          ? "8px"
          : "",
      borderBottom: ".5px solid #29afff77",
    };
    let iconName = `${
      HARDWARE_TYPE[hardwareType.toUpperCase()]?.icon ?? HARDWARE_TYPE.TAB.icon
    }`;

    const configurationId =
      hardwareDetails[hardwareModel][0].deviceConfigurationId;
    const configurationName =
      hardwareDetails[hardwareModel][0].deviceConfigurationName;
    const uniqueKey = `${productType}-${hardwareModel}-${hardwareType}`;
    const enableQRModel =
      configurationId != null &&
      groupId != null &&
      Number.isFinite(Number(configurationId)) &&
      Number.isFinite(Number(groupId)) &&
      hardwareType.toUpperCase() === HARDWARE_TYPE.TAB.name.toUpperCase();
    return (
      <Row
        className="hardware-info-row"
        style={colStyle}
        onClick={() => {
          if (enableQRModel) {
            handleQRClick(uniqueKey);
          }
        }}
      >
        <Row className="hardware-info-row">
          <FontAwesomeIcon
            icon={iconName}
            size="2x"
            style={{ marginRight: "10px" }}
          />
          <Col className="hardware-info-col">
            <div className="summary-value">{!!count ? count : "NA"}</div>
            <div className="summary-label">
              {hardwareModel} {hardwareType}
            </div>
          </Col>
        </Row>
        {enableQRModel ? (
          <Row className="hardware-info-row">
            <QRCodeComponent
              title={`${hardwareModel} ${hardwareType}: ${
                configurationName ?? ""
              }`}
              isModalOpen={isModalOpen === uniqueKey}
              config={configurationId}
              group={groupId}
              handleQRClick={() => {
                handleQRClick(uniqueKey);
              }}
            />
          </Row>
        ) : (
          <Row
            className="hardware-info-row"
            style={{
              justifyContent: "end",
              marginRight: "10px",
            }}
          >
            {hardwareType.toUpperCase() ===
              HARDWARE_TYPE.TAB.name.toUpperCase() && (
              <FontAwesomeIcon icon={"link-slash"} color={"black"} size="2x" />
            )}
          </Row>
        )}
      </Row>
    );
  };

  return (
    <Row className="hardware-info-header">
      {hardwareDetails &&
        Object.keys(hardwareDetails)?.map((key, index) => {
          return cardDetailsLayout(key, index);
        })}
    </Row>
  );
};

export default HardwareDetailsComponent;
